﻿// @ts-ignore
import * as TL from '@knight-lab/timelinejs';
import '@knight-lab/timelinejs/dist/css/timeline.css';

interface DotNetRef {
    invokeMethodAsync(methodName: string, ...args: unknown[]): Promise<unknown>;
}

class OmTimeLineJS {
    private timeline: any;
    private readonly elementId: string;
    private readonly dotNetRef?: DotNetRef;
    private readonly options: any;

    constructor(elementId: string, dotNetRef?: DotNetRef, data?: any, options?: any) {
        this.elementId = elementId;
        this.dotNetRef = dotNetRef;
        this.options = options || {};

        this.initialize(data);
    }

    private initialize(data: any): void {
        // @ts-ignore
        const timelineClass = (window as any).TL?.Timeline || TL.Timeline;
        if (!timelineClass) {
             console.error("TimelineJS (TL.Timeline) not found. Make sure it is loaded correctly.");
             return;
        }

        this.timeline = new timelineClass(this.elementId, data, this.options);

        if (this.dotNetRef) {
            this.timeline.on('change', (eventData: any) => {
                this.dotNetRef?.invokeMethodAsync('OnSlideChanged', eventData.unique_id);
            });
        }
    }

    public setData(data: any): void {
        // Re-initialize for new data if needed, or if TL supports it.
        // TL doesn't have a great 'setData', so we often recreate.
        // But first let's see if we can just destroy and recreate.
        if (this.timeline) {
            // TL doesn't have a public destroy() in some versions, but we can clear the element.
            const container = document.getElementById(this.elementId);
            if (container) {
                container.innerHTML = '';
            }
        }
        this.initialize(data);
    }
}

export function Create(elementId: string, dotNetRef?: DotNetRef, data?: any, options?: any): OmTimeLineJS {
    return new OmTimeLineJS(elementId, dotNetRef, data, options);
}

export function SetData(instance: OmTimeLineJS, data: any): void {
    instance.setData(data);
}

export default {
    Create,
    SetData
};
